export enum CornerMarketsDisabledAttribute {
  Master = 837,
}
